export default __webpack_public_path__ + "static/media/accountability.49d99b8a.png";